<template>
	<value-container v-if="view_only" :value="value" :label="label" :md="md"/>
	<component v-else :is='tag' :md2="md==2" :md3="md==3" :md4="md==4" :md6="md==6" :md8="md==8" :md12="md==12">
		<slot></slot>
	</component>
</template>

<script>
export default {
	props: ['value', 'label','md','tag','view_only'],
};
</script>
